import { render, staticRenderFns } from "./OidcSilentRenewal.vue?vue&type=template&id=5aecde30&"
import script from "./OidcSilentRenewal.vue?vue&type=script&lang=js&"
export * from "./OidcSilentRenewal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports